'use client';
import { _ as _extends, a as _object_without_properties_loose } from './cc-zJdVkWBV.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { CheckIcon, CircleIcon, ChevronRightIcon } from 'lucide-react';
import { cn } from '@repo/lib/utils';

function DropdownMenu(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.Root, _extends({
        "data-slot": "dropdown-menu"
    }, props));
}
function DropdownMenuPortal(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.Portal, _extends({
        "data-slot": "dropdown-menu-portal"
    }, props));
}
function DropdownMenuTrigger(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.Trigger, _extends({
        "data-slot": "dropdown-menu-trigger"
    }, props));
}
function DropdownMenuContent(_0) {
    let { className, sideOffset = 4 } = _0, props = _object_without_properties_loose(_0, [
        "className",
        "sideOffset"
    ]);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.Portal, {
        children: /*#__PURE__*/ jsx(DropdownMenuPrimitive.Content, _extends({
            "data-slot": "dropdown-menu-content",
            sideOffset: sideOffset,
            className: cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md", className)
        }, props))
    });
}
function DropdownMenuGroup(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.Group, _extends({
        "data-slot": "dropdown-menu-group"
    }, props));
}
function DropdownMenuItem(_0) {
    let { className, inset, variant = "default" } = _0, props = _object_without_properties_loose(_0, [
        "className",
        "inset",
        "variant"
    ]);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.Item, _extends({
        "data-slot": "dropdown-menu-item",
        "data-inset": inset,
        "data-variant": variant,
        className: cn("focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
    }, props));
}
function DropdownMenuCheckboxItem(_0) {
    let { className, children, checked } = _0, props = _object_without_properties_loose(_0, [
        "className",
        "children",
        "checked"
    ]);
    return /*#__PURE__*/ jsxs(DropdownMenuPrimitive.CheckboxItem, _extends({
        "data-slot": "dropdown-menu-checkbox-item",
        className: cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className),
        checked: checked
    }, props, {
        children: [
            /*#__PURE__*/ jsx("span", {
                className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center",
                children: /*#__PURE__*/ jsx(DropdownMenuPrimitive.ItemIndicator, {
                    children: /*#__PURE__*/ jsx(CheckIcon, {
                        className: "size-4"
                    })
                })
            }),
            children
        ]
    }));
}
function DropdownMenuRadioGroup(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.RadioGroup, _extends({
        "data-slot": "dropdown-menu-radio-group"
    }, props));
}
function DropdownMenuRadioItem(_0) {
    let { className, children } = _0, props = _object_without_properties_loose(_0, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ jsxs(DropdownMenuPrimitive.RadioItem, _extends({
        "data-slot": "dropdown-menu-radio-item",
        className: cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
    }, props, {
        children: [
            /*#__PURE__*/ jsx("span", {
                className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center",
                children: /*#__PURE__*/ jsx(DropdownMenuPrimitive.ItemIndicator, {
                    children: /*#__PURE__*/ jsx(CircleIcon, {
                        className: "size-2 fill-current"
                    })
                })
            }),
            children
        ]
    }));
}
function DropdownMenuLabel(_0) {
    let { className, inset } = _0, props = _object_without_properties_loose(_0, [
        "className",
        "inset"
    ]);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.Label, _extends({
        "data-slot": "dropdown-menu-label",
        "data-inset": inset,
        className: cn("px-2 py-1.5 text-sm font-medium data-[inset]:pl-8", className)
    }, props));
}
function DropdownMenuSeparator(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.Separator, _extends({
        "data-slot": "dropdown-menu-separator",
        className: cn("bg-border -mx-1 my-1 h-px", className)
    }, props));
}
function DropdownMenuShortcut(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx("span", _extends({
        "data-slot": "dropdown-menu-shortcut",
        className: cn("text-muted-foreground ml-auto text-xs tracking-widest", className)
    }, props));
}
function DropdownMenuSub(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.Sub, _extends({
        "data-slot": "dropdown-menu-sub"
    }, props));
}
function DropdownMenuSubTrigger(_0) {
    let { className, inset, children } = _0, props = _object_without_properties_loose(_0, [
        "className",
        "inset",
        "children"
    ]);
    return /*#__PURE__*/ jsxs(DropdownMenuPrimitive.SubTrigger, _extends({
        "data-slot": "dropdown-menu-sub-trigger",
        "data-inset": inset,
        className: cn("focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[inset]:pl-8", className)
    }, props, {
        children: [
            children,
            /*#__PURE__*/ jsx(ChevronRightIcon, {
                className: "ml-auto size-4"
            })
        ]
    }));
}
function DropdownMenuSubContent(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(DropdownMenuPrimitive.SubContent, _extends({
        "data-slot": "dropdown-menu-sub-content",
        className: cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-lg", className)
    }, props));
}

export { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger };
